var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1456 404L1456 432",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1456.5,
    cy: 399.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1451.99 399.19C1451.99 395.283 1455.29 392.117 1459.36 392.117C1459.94 392.117 1460.51 392.184 1461.06 392.308C1459.74 391.48 1458.19 391 1456.52 391C1451.81 391 1448 394.806 1448 399.5C1448 404.194 1451.81 408 1456.52 408C1458.81 408 1460.89 407.093 1462.43 405.62C1461.49 406.032 1460.45 406.263 1459.36 406.263C1455.29 406.263 1451.99 403.096 1451.99 399.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1465.4 398.6L1465.37 396.146L1463.54 397.719L1461.3 397.056L1462.11 399.337L1460.77 401.381L1463.1 401.218L1464.5 403.144L1465.13 400.763L1467.34 399.909L1465.4 398.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch2);
export default __webpack_public_path__ + "static/media/church_2.6cc7531ddc0617020465499c62b176dc.svg";
export { ForwardRef as ReactComponent };